"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductivityMenuButton = exports.ControlsMenuButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const styled_components_1 = __importDefault(require("styled-components"));
function ControlsMenuButton(props) {
    const { isMobile } = (0, device_1.usePlatform)();
    return isMobile ? ((0, jsx_runtime_1.jsx)(MobileMenuButton, Object.assign({}, props, { "aria-pressed": props.selected, "data-e2e": 'ControlsMenuButton_MobileMenuButton' }))) : ((0, jsx_runtime_1.jsx)(exports.ProductivityMenuButton, Object.assign({}, props, { "aria-pressed": props.selected, "data-e2e": 'ControlsMenuButton_ProductivityMenuButton' })));
}
exports.ControlsMenuButton = ControlsMenuButton;
exports.ProductivityMenuButton = styled_components_1.default.button `
  display: block;
  width: 100%;
  height: 32px;
  padding: 6px 0 6px 4px;

  color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  font-size: 9px;
  line-height: 12px;
  text-align: left;
  text-transform: uppercase;

  background: transparent;

  border: none;
  outline: none;

  cursor: pointer;

  user-select: none;

  &:disabled {
    cursor: auto;
    opacity: 0.3;
  }
`;
const MobileMenuButton = styled_components_1.default.button `
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  padding: 0 4px;

  color: ${({ selected, theme }) => (selected ? theme.text : theme.disabled)};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;

  background-color: ${({ selected, theme }) => selected ? theme.backgroundWithOpacityLight : theme.backgroundWithOpacity};
  border: none;
  outline: none;

  cursor: pointer;

  &:disabled {
    cursor: auto;
    opacity: 0.3;
  }

  &:not(:first-child) {
    margin-left: 0;
  }
`;
